module.exports = __webpack_public_path__ + "img/top-bar.3d238830.png";